export const MAX_COMPANY_IN_PORTFOLIO = 500
